function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import clsx from "clsx";
import { isTruthy } from "./isTruthy";
import { UnreachableCaseError } from "./unreachable-case-error";
export function buildNavigationTree(items) {
  var localeItems = items;
  function buildTree(parent, items) {
    var children = items.filter(function (item) {
      return item.parent === (parent === null || parent === void 0 ? void 0 : parent.id);
    });
    return _object_spread_props(_object_spread({}, parent), {
      children: children.map(function (child) {
        return _object_spread_props(_object_spread({}, child), {
          children: buildTree(child, items).children
        });
      })
    });
  }
  return localeItems.filter(function (item) {
    return !item.parent;
  }).map(function (item) {
    return buildTree(item, localeItems);
  });
}
function extractItemsByLocale(input, langcode) {
  return input.filter(function (item) {
    return item.langcode === langcode;
  }).pop();
}
export var MENUS = ["fast-navigation-menu", "footer-menu", "footer-quicklinks-activecom", "footer-quicklinks-gv", "footer-quicklinks-orthotec", "footer-quicklinks-orthotecsports", "footer-quicklinks-parahelp", "footer-quicklinks-sirmed", "footer-quicklinks-spf", "footer-quicklinks-sportmedi", "footer-quicklinks-sps", "footer-quicklinks-spz", "footer-social-menu", "footer-social-menu-activecom", "footer-social-menu-orthotec", "footer-social-menu-parahelp", "footer-social-menu-sirmed", "footer-social-menu-spf", "footer-social-menu-sps", "footer-social-menu-spz", "home-menu", "main", "meta-navigation", "meta-navigation-orthotecsports", "meta-navigation-left", "sidebar-ac", "sidebar-gv", "sidebar-orthotec", "sidebar-orthotecsports", "sidebar-parahelp", "sidebar-sirmed", "sidebar-spf", "sidebar-sportmedizin", "sidebar-sps", "sidebar-spz"];
// @todo process maxDepth
export var menuItems = function menuItems(id, result, locale) {
  var _extractItemsByLocale;
  var menuTranslations;
  switch (id) {
    case "fast-navigation-menu":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFastNavigation;
      break;
    case "footer-menu":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooter;
      break;
    case "footer-quicklinks-activecom":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksActiveCom;
      break;
    case "footer-quicklinks-gv":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksGonnerVereinigung;
      break;
    case "footer-quicklinks-orthotec":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksOrthotec;
      break;
    case "footer-quicklinks-orthotecsports":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksOrthotecSports;
      break;
    case "footer-quicklinks-parahelp":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksParahelp;
      break;
    case "footer-quicklinks-sirmed":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksSirmed;
      break;
    case "footer-quicklinks-spf":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksSpf;
      break;
    case "footer-quicklinks-sportmedi":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksSportMedizin;
      break;
    case "footer-quicklinks-sps":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksSps;
      break;
    case "footer-quicklinks-spz":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuFooterQuickLinksSpz;
      break;
    case "footer-social-menu":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSocial;
      break;
    case "footer-social-menu-activecom":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSocialActiveCom;
      break;
    case "footer-social-menu-orthotec":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSocialOrthotec;
      break;
    case "footer-social-menu-parahelp":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSocialParahelp;
      break;
    case "footer-social-menu-sirmed":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSocialSirmed;
      break;
    case "footer-social-menu-spf":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSocialSpf;
      break;
    case "footer-social-menu-sps":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSocialSps;
      break;
    case "footer-social-menu-spz":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSocialSpz;
      break;
    case "home-menu":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuHome;
      break;
    case "main":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuMain;
      break;
    case "meta-navigation":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuMetaNavigation;
      break;
    case "meta-navigation-orthotecsports":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuMetaNavigationOrthotecSports;
      break;
    case "sidebar-ac":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarActiveCommunication;
      break;
    case "sidebar-gv":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarGonnerVereinigung;
      break;
    case "sidebar-orthotec":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarOrthotec;
      break;
    case "sidebar-orthotecsports":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarOrthotecSports;
      break;
    case "sidebar-parahelp":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarParahelp;
      break;
    case "sidebar-sirmed":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarSirmed;
      break;
    case "sidebar-spf":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarSpf;
      break;
    case "sidebar-sportmedizin":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarSportMedizin;
      break;
    case "sidebar-sps":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarSps;
      break;
    case "sidebar-spz":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuSidebarSpz;
      break;
    case "meta-navigation-left":
      menuTranslations = result === null || result === void 0 ? void 0 : result.menuMetaNavigationLeft;
      break;
    default:
      throw new UnreachableCaseError(id);
  }
  var menuItems = ((_extractItemsByLocale = extractItemsByLocale((menuTranslations === null || menuTranslations === void 0 ? void 0 : menuTranslations.filter(isTruthy)) || [], locale)) === null || _extractItemsByLocale === void 0 ? void 0 : _extractItemsByLocale.items) || [];
  return buildMenuTree(menuItems);
};
export var buildMenuTree = function buildMenuTree() {
  var menu = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [],
    parent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return menu.filter(function (item) {
    return item.parent === parent;
  }).map(function (item) {
    return {
      id: item.id,
      title: item.label,
      url: item.url,
      attributes: {
        title: item.titleAttribute,
        class: item.classAttribute,
        id: item.idAttribute,
        ariaControls: item.ariaControlsAttribute,
        ariaExpanded: item.ariaExpandedAttribute === "true",
        ariaHasPopup: item.ariaHasPopupAttribute === "true",
        accessKey: item.accessKeyAttribute,
        target: item.targetAttribute,
        enabled: item.isEnabled
      },
      childItems: buildMenuTree(menu, item.id)
    };
  });
};
export var addClassToMenuItems = function addClassToMenuItems() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }
  return function (items) {
    return items.map(function (menuItem) {
      var _menuItem_attributes;
      return _object_spread_props(_object_spread({}, menuItem), {
        attributes: _object_spread_props(_object_spread({}, menuItem.attributes), {
          class: clsx(classes, (_menuItem_attributes = menuItem.attributes) === null || _menuItem_attributes === void 0 ? void 0 : _menuItem_attributes.class)
        }),
        childItems: menuItem.childItems ? addClassToMenuItems(classes)(menuItem.childItems) : undefined
      });
    });
  };
};